module.exports = __webpack_public_path__ + "img/classify_14.b112b09c.png";